export function createFormData(data: Record<string, any>) {
	const formData = new FormData();

	Object.entries(data).forEach(([key, value]) => {
		if (value === undefined || value === null) return;

		if (value instanceof File) {
			formData.append(key, value);
			return;
		}

		if (Array.isArray(value)) {
			if (key === 'class' || key === 'culture' || key === 'commonPests' || key === 'activeIngredients' || key === 'areas') {
				formData.append(key, JSON.stringify(value));
				return;
			}
			value.forEach((item) => {
				if (item instanceof File) {
					formData.append(key, item);
				} else if (typeof item === 'object') {
					formData.append(key, JSON.stringify(item));
				} else {
					formData.append(key, String(item));
				}
			});

			return;
		}

		if (typeof value === 'object') {
			formData.append(key, JSON.stringify(value));
			return;
		}

		formData.append(key, String(value));
	});

	return formData;
}
